import { createSelector } from '@ngrx/store';
import * as fromApp from '../app.reducer';
import * as fromDoc from '../reducers/doc.reducer';

export const selectDocState = createSelector(
  fromApp.selectAppState,
  (state: fromApp.AppState) => state.docs
);

export const selectDoc = createSelector(selectDocState, (state) => state.doc);
export const selectDocError = createSelector(
  selectDocState,
  (state) => state.error
);
export const selectDocLoading = createSelector(
  selectDocState,
  (state) => state.loading
);

export const selectCatalogError = createSelector(
  selectDocState,
  (state) => state.error
);
export const selectOptimisticLockError = createSelector(
  selectDocState,
  (state) => state.optimisticLockError
);


export const selectCrudCompleted = createSelector(
  selectDocState,
  (state) => state.crudCompleted
);

export const selectDocsEntities = createSelector(
  selectDocState,
  fromDoc.selectEntities
);

export const selectUploadedFile = createSelector(
  selectDocState,
  (state) => state.uploadedFile
);

export const selectFileRemoved = createSelector(
  selectDocState,
  (state) => state.removedFile
);

export const selectAllDocs = createSelector(selectDocState, fromDoc.selectAll);

export const selectDocsTotalCount = createSelector(
  selectDocState,
  (state) => state.totalCount
);
export const selectFileDocError = createSelector(
  selectDocState,
  (state) => state.fileError
);
export const selectBlobErrorMsg = createSelector(
  selectDocState,
  (state) => state.blobError
);


